import { SideMenu } from "../../../../Wrap/Constants/Enums/Menu/SideMenu";

export interface IParameterModel {
    SideMenu: SideMenu;
    clAccountId?: string;
    hierarchyId?: string;
    customerId?: number;
}

export interface IActionMenuParamsModel {
    SideMenu: SideMenu;
    subaccountHierarchyId: string;
    headaccounthierarchyId: string;
    levelHierarchyId: string;
}

export const subAccountActionMenu = [
    SideMenu.WrapCash,
    SideMenu.PersonalPortfolio,
    SideMenu.IsaCash,
    SideMenu.IsaStocks,
    SideMenu.OldSipp,
    SideMenu.NewSipp,
    SideMenu.OffshoreBond,
    SideMenu.OnshoreBond,
];
